{
    angular.module('interfaceModule')
        .controller('UploadingController',UploadingController);
    UploadingController.$inject = ['$scope',"$q",'utils.constant','$state',
    'utils.uploadManager',"request.file",'$timeout','utils.currentUser',
    'utils.common'];
    function UploadingController($scope,$q,constant,$state,
    	uploadManager,fileRequest,$timeout,currentUser,
        common) {
        let vm=this;
        let collect={
            'activate':activate,
            'uploader':null,
            'progress':100,
            'fileName':'',
            'onChecking':false,
            'cancelUpload':cancelUpload,
            'delegate':null,
            'timer':null,
            'count_time':0,
            'normal_check':false,
            'img_wait':false
        };
        vm.collect=collect;
        activate();

        function activate(){
            // console.log('UploadingController,activate');

            uploadManager.init();

            if(!uploadManager.currentFileItem){
                $state.go('main.home');
                return;
            }
            collect.uploader=uploadManager.uploader;

            let delegate=collect.delegate={};

            delegate.onAfterAddingFile = function(fileItem) {
                collect.fileName=uploadManager.currentFileItem.file.name;
            };
            delegate.onProgressItem=function(fileItem, progress) {
                collect.progress=progress;
            };
            delegate.onSuccessItem = function(fileItem, response, status, headers) {
                console.log(response);
                if(response.userid==null||response.docid==null){
                    let alert=common.alert('','请重新登录再操作',[{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            $state.go('login');
                        }
                    }]);
                }else{
                    getDocInfo();
                }

            };
            delegate.onErrorItem = function(fileItem, response, status, headers) {
                common.alert('','文件上传失败',[{
                    'title':'确定',
                    'action':function(){
                        alert.close();
                        $state.go('main.home');
                    }
                }]);
            };
            delegate.onCancelItem = function(fileItem, response, status, headers) {

            };
            delegate.onCompleteItem = function(fileItem, response, status, headers) {
                
            };
            uploadManager.callbackDelegateList.push(delegate);


            $scope.$on("$destroy", function(e) {
                //console.log('监控到了：');
                if($scope==e.targetScope){
                    uploadManager.callbackDelegateList
                        .splice(uploadManager.callbackDelegateList.indexOf(delegate),1);
                    delegate=null;
                    collect.uploader.cancelAll();
                    uploadManager.currentFileItem=null;
                }
            })

            

            collect.fileName=uploadManager.currentFileItem.file.name;
            console.log('fileName:'+ collect.fileName);
            if(!collect.uploader.isUploading){
                collect.progress=100;
                getDocInfo();
            }
        }


        function getDocInfo(){
            collect.onChecking=true;
            collect.uploader.clearQueue();
            getUploadResult().then(function(resultData){
                //console.log('得到的doc信息：',resultData);
                // console.log(fileItem.printType);
                collect.onChecking=false;
                if(resultData.fileData.pageNum>300){
                    let alert=common.alert('','该文件页数太多，请选择其他文件',[{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            $state.go('main.home');
                        }
                    }]);
                }else if(resultData.fileData.pageNum==-1){
                    let alert=common.alert('','您上传的文件包含密码（或打印密码），请把密码删除后，重新上传文件!',[{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            $state.go('main.home');
                        }
                    }]);
                }else{
                    $state.go('main.printSettings',
                        {'printType':uploadManager.currentFileItem.printType});
                }

            });
        }

        //取消上传
        function cancelUpload(){
            collect.uploader.cancelAll();
            collect.onChecking=false;
            $timeout.cancel(collect.timer);
            $state.go('main.home');
        }

        function getUploadResult(){
            let def=$q.defer();
            let check=function (){
                fileRequest.getUploadResult().then(function(data){
                    console.log('getUploadResult',data);
                    let locationUrl = window.location.href;
                    let urlReg = /^\S+uploading$/;//地址是否以uploading结尾
                    if(collect.onChecking && urlReg.test(locationUrl)){
                        collect.normal_check=true;
                        if(data.result==1){
                            def.resolve(data);
                        }else if(data.result==2){
                            collect.normal_check=false;
                            collect.img_wait=true;
                            collect.count_time++;
                            collect.timer=$timeout(function(){
                                check();
                            },1000);
                        }
                        else{
                            collect.timer=$timeout(function(){
                                check();
                            },1000);
                            
                        }
                    }
                    
                });
            }
            check();
            return def.promise;
        }
    }

}